module.exports = __webpack_public_path__ + "static/media/default_thumbnail_1280_720.7474462d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnail/default_thumbnail_1280_720.jpg
// module id = 314
// module chunks = 2